import { HSIconType } from '@types';
import { MainPlayer } from '@stores/krpPlayerStores';

function getHotspotTitleId(id: string, iconType?: HSIconType) {
  if (iconType === HSIconType.mark) return id;
  return MainPlayer.get()?.getHotspotById(id)?.titleHotspotId;
}

export default getHotspotTitleId;
